import {FuseLoadable} from '@fuse';

export const M3OperationsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/millenniumiaas/M3Operations',
            component: FuseLoadable({
                loader: () => import('./M3Operations')
            })
        },
      
       
      

    ]
};

